<div *ngIf="fieldsGroup" class="interface-control__custom-input-autocomplete__label">
  {{ data.label }}
</div>
<bfx-autoComplete
  #inputField
  [(ngModel)]="data.value"
  [label]="fieldsGroup ? null : label"
  [suggestions]="data.filteredItems"
  (completeMethod)="search($event)"
  [disabled]="disabled || locked"
  (onFocus)="onFocus($event)"
  (onBlur)="onBlur($event)"
  (onSelect)="onSelect($event)"
  dataKey="dataItem"
  field="label"
  [autoHighlight]="true"
  [skipSorting]="true"
  delay="4"
  nativeDesktopDropdown="algoType"
  target="algoType"
  [state]="data.state"
  [dropdown]="true"
  [minLength]="1"
  [size]="'sm'"
  [appendTo]="'body'"
  class="interface-control__custom-input-autocomplete__autocomplete"
>
  <ng-template let-dataItem pTemplate="item">
    <div
      class="ui-helper-clearfix"
      [ngClass]="{
        'bfx-autocomplete_dropdown-list_field': !dataItem.lastFavorite,
        'bfx-autocomplete_dropdown-list_last-favorite': dataItem.lastFavorite
      }"
    >
      <div>{{dataItem.label}}</div>
    </div>
  </ng-template>
</bfx-autoComplete>
